// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FileDropzone.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { DropTarget, DragDropContext, DragDropContextProvider } from 'react-dnd';
import HTML5Backend, { NativeTypes } from 'react-dnd-html5-backend';

const Target = ({
  canDrop,
  isOver,
  connectDropTarget,
  render
}: {
  canDrop: boolean,
  isOver: boolean,
  connectDropTarget: any,
  render: any
}): any => (
  <DragDropContextProvider backend={HTML5Backend}>
    {connectDropTarget(<div>{render({ canDrop, isOver })}</div>)}
  </DragDropContextProvider>
);

const FileDropzone = compose(
  DragDropContext(HTML5Backend),
  DropTarget(
    ({ accepts }) => accepts || [NativeTypes.FILE],
    {
      drop(props, monitor) {
        if (monitor) {
          const { files } = monitor.getItem();
          props.onDrop(files, monitor.internalMonitor);
        }
      }
    },
    (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  )
)(Target);

FileDropzone.displayName = 'FileDropzone';
FileDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  accepts: PropTypes.arrayOf(PropTypes.string)
};

export default FileDropzone;



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.FileDropzone.js